import env from '@/lib/env'

export const copyrightYear = new Date().getFullYear()
export const privacyPolicyLink = `${env.BASE_PATH}/privacy-policy`
export const termOfUseLink = `${env.BASE_PATH}/terms-of-use`
